import * as Sentry from '@sentry/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ConnectionProblemPage } from './ConnectionProblemPage'

export function ClerkFailedPage() {
  const { t } = useTranslation()
  const [sentryEventId, setSentryEventId] = useState<string | undefined>()

  useEffect(() => {
    const eventId = Sentry.captureMessage('Clerk SDK failed to load', {
      level: 'error',
      tags: { error_type: 'clerk_failed', url: window.location.href },
      extra: { userAgent: navigator.userAgent },
    })
    setSentryEventId(eventId)
  }, [])

  return (
    <ConnectionProblemPage
      subtitle={t('connectionProblem.subtitleAuth')}
      onRetry={() => window.location.reload()}
      errorContext={{
        error_type: 'clerk_failed',
        url: window.location.href,
        user_agent: navigator.userAgent,
        sentry_event_id: sentryEventId,
      }}
    />
  )
}
